<template>
  <v-layout
    row
    wrap
    class="text-xs-center align-content-center"
    fill-height
  >
    <v-flex xs12>
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="60"
        color="primary"
      />
    </v-flex>

    <v-flex
      v-if="!loading"
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
    >
      <AppointmentsTable
        :turnos="turnosPendientes"
        @openCancelModal="openCancelModal"
      />
    </v-flex>
    <AppointmentAcceptModal
      :message="verificationMessage"
      :appointment="selectedAppointment"
      :visible="dialogOpen"
      @accepted="appointmentAccepted"
    />
    <AppointmentCancelModal
      :visible="openedCancelModal"
      :appointment="selectedAppointment"
      @reloadAppointments="loadAppointments"
      @cancel="closeModal"
    />
  </v-layout>
</template>

<script>
import AppointmentsTable from '../components/appointments/AppointmentsTable'
import { getTurnosPendientes } from '../api/appointmentsEndpoints'
import { mapGetters } from 'vuex'
import AppointmentCancelModal from '../components/appointments/AppointmentCancelModal'
import AppointmentAcceptModal from '../components/appointments/AppointmentAcceptModal'

export default {
  name: 'AppoinmentsView',
  components: {
    AppointmentCancelModal,
    AppointmentsTable,
    AppointmentAcceptModal
  },
  data () {
    return {
      dialogOpen: false,
      verificationMessage: '',
      turnosPendientes: [],
      selectedAppointment: {},
      openedCancelModal: false,
      loading: false,
      headers: [
        { text: 'Hora', value: 'hora', class: 'small-width' },
        { text: 'Profesional', value: 'profesional' },
        { text: 'Reserva', value: null, class: 'subheading font-weight-bold', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'getSelectedAppointment'])
  },
  async mounted () {
    this.loading = true
    await this.loadAppointments()
    if (this.$route.params.appointment) {
      this.openDialog(this.$route.params.appointment)
    }
    this.loading = false
  },
  methods: {
    async loadAppointments () {
      this.turnosPendientes = await getTurnosPendientes(this.user.id)
    },
    openCancelModal (props) {
      this.selectedAppointment = props
      this.openedCancelModal = true
    },
    async closeModal () {
      this.openedCancelModal = false
      this.dialogOpen = false
    },
    openDialog (props) {
      this.dialogOpen = true
      this.selectedAppointment = { ...props.appointment }
      this.verificationMessage = props.verification
    },
    async appointmentAccepted () {
      this.dialogOpen = false
      this.verificationMessage = ''
      await this.$store.dispatch('setSelectedAppointment', null)
      await this.loadAppointments()
    }
  }
}
</script>

<style scoped>

</style>
